<p>
  news-notification works!
</p>
